export default "__VITE_ASSET__am6X6spP__"